"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const SVGHoverable = ({ children, onClick, styles, className, baseColor = "var(--color-gray-700)", hoverColor = "var(--color-white)", }) => {
    const [hovered, setHovered] = (0, react_1.useState)(false);
    return ((0, jsx_runtime_1.jsx)("span", Object.assign({ style: Object.assign({ cursor: "pointer" }, styles), onClick: onClick, className: `transition-ease ${className}`, onMouseEnter: () => setHovered(true), onMouseLeave: () => setHovered(false) }, { children: children({ color: hovered ? hoverColor : baseColor }) })));
};
exports.default = SVGHoverable;
